/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeAuthLogin = 'route-_auth-login',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang)._auth.login',
}

/* -------------------------------------------------------------------------------------------------
 * Redirected from
 * -----------------------------------------------------------------------------------------------*/

enum REDIRECTED_FORM {
	registration = 'registration',
	resetPassword = 'reset-password',
	resetPasswordToken = 'reset-password-token',
	accountVerification = 'account-verification',
}

/* -------------------------------------------------------------------------------------------------
 * Search params
 * -----------------------------------------------------------------------------------------------*/

enum SEARCH_PARAMS {
	from = 'from',
	email = 'email',
	verified = 'verified',
}

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as LOGIN_I18NEXT,
	ROUTE_LOADER as LOGIN_ROUTE_LOADER,
	REDIRECTED_FORM as LOGIN_REDIRECTED_FORM,
	SEARCH_PARAMS as LOGIN_SEARCH_PARAMS,
}
